import React, { useState } from 'react';
import ReactPlayer from 'react-player'
// import img from '../assets/video_preview.jpg';
// import video from '../assets/intro.mp4';

const Hero = () => {

  // const [previewClicked, setPreviewClicked] = useState(false)

  // const onClickPreview = () => {
  //   setPreviewClicked(!previewClicked)
  // }

  return (
    <div className="Hero">
      <div className="Hero__TextWrapper">
        <h1 className="Hero__Payoff">
          Scheduling<br /> made simple.
        </h1>
        <h2 className="Hero__Subtitle">Operated with <span aria-label="love" role="img">💙</span> by <a href="https://www.agr-software.com" title="AGR Software">AGR Software</a></h2>
      </div>
      <div className="Hero__ImageWrapper">
        <div className="Hero__VideoOuterWrapper">
          <div className="Hero__VideoWrapper">
            {/* <ReactPlayer className='react-player' onClickPreview={onClickPreview} light={img}  url={video} controls={true} width={"100%"} height={"100%"} /> */}
            <ReactPlayer className='react-player'  width={"100%"} height={"100%"} url='https://www.youtube.com/watch?v=vZjY_1SU9MY' />
          </div>
        </div>

        {/* <img className="Hero__Image" alt="Rig" src={img} /> */}
      </div>
    </div>
  );
};

export default Hero;



// WEBPACK FOOTER //
// ./src/components/Hero.js